import { useContext, useState, useEffect } from 'react';
import './PageMultiSlider.css';
import Slider from '../../generics/Slider';
import messages from '../../lang/preferences';
import { SlidesContext } from '../../contexts/SlidesContext';
import ReviewFormattedMessage from '../../generics/ReviewFormattedMessage';

export default function PageMultiSlider ( {slide} ) {
  const { slidesAnswers, updateValues} = useContext(SlidesContext);
  const [slidersStatus, setSliderStatus] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    let slidersStatus = [];
    if (slide.inputsMS) {
      slide.inputsMS.forEach(el => slidersStatus.push(false));
    }
    setSliderStatus(slidersStatus);
    setCurrentSlide(slide.inputNumber)
  }, [slide])

  const changeSliderStatus = (index,key,value) => {
    //Rajouter le tableau en plus a envoyer
    let newSliderStatus = slidersStatus;
    for (let i = 0; i < slidersStatus.length; i++){
      if(key.indexOf(`POSSIBILITE${i+1}`) !== -1){
        newSliderStatus[i] = true;
        setSliderStatus(newSliderStatus)
      }
    }
    updateValues(index, key, value);
  }

  const refreshMultiSlider = () => {
    let slidersStatus = [];
    if(slide.inputNumber !== currentSlide){
      if (slide.inputsMS) {
        slide.inputsMS.forEach(el => slidersStatus.push(false));
      }
      setSliderStatus(slidersStatus);
      setCurrentSlide(slide.inputNumber)
    } 
  }
    return (
      <div className="PageMultiSlider animate__animated animate__fadeInRight">
        <div className="Slide-help" ><ReviewFormattedMessage descriptor={messages.INFOINST7BIS}/></div>
        <div className="PageMultiSlider-situation">
            <ReviewFormattedMessage descriptor={slide.situationText} />
        </div>
        <div className="PageMultiSlider-question">
          <h2><ReviewFormattedMessage descriptor={slide.question}/></h2>
        </div>
        <div className="PageMultiSlider-list">
          <div className="Slider">
            <div className="Slider-affirmation"><span></span></div>
            <div className="Slider-niveauSituation">
              <span><ReviewFormattedMessage descriptor={slide.pasDuToutText}/></span>
              <span><ReviewFormattedMessage descriptor={slide.tresFortementText}/></span>
            </div>
          </div>
          {
            Array.isArray(slide.inputsMS) && slide.inputsMS.map((slider, key) => {
              return (
                <div key={key}>
                  <Slider
                    isPartOfGroup="true" 
                    slidersStatus={slidersStatus}
                    changeSliderStatus={changeSliderStatus} 
                    stepRange={slide.stepRange} 
                    label={slider.labelMS} 
                    value={slidesAnswers[slide.inputNumber][slider.key]} 
                    index={slide.inputNumber} 
                    inputKey={slider.key}
                    pasDuToutText={slide.pasDuToutText}
                    tresFortementText={slide.tresFortementText}
                    afficherNiveau={slider.afficherNiveau}
                  />
                </div>
                )
            })
          }
          {
            refreshMultiSlider()
          }
        </div>
      </div>
    );
}